import { render, staticRenderFns } from "./GroupTenant.vue?vue&type=template&id=f2ad69a6&scoped=true"
import script from "./GroupTenant.vue?vue&type=script&lang=js"
export * from "./GroupTenant.vue?vue&type=script&lang=js"
import style0 from "./GroupTenant.vue?vue&type=style&index=0&id=f2ad69a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ad69a6",
  null
  
)

export default component.exports